import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/certInfo/:param",
      name: "certInfo",
      component: resolve => require(['./views/cert/certInfo/index.vue'], resolve),
      meta: {
        single: true
      }
    },
    {
      path: "/",
      name: "home",
      component: resolve => require(['./views/home.vue'], resolve)
    },
    {
      path: "/tspDynamicsList",
      name: "tspDynamicsList",
      component: resolve => require(['./views/coteDynamics/list.vue'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/tspDynamicsDetail/:newsId",
      name: "tspDynamicsDetail",
      meta: {
        parent: 'tspDynamicsList'
      },
      component: resolve => require(['./views/coteDynamics/detail.vue'], resolve)
    },
    {
      path: "/onlineServiceList",
      name: "onlineServiceList",
      component: resolve => require(['./views/onlineService/list.vue'], resolve)
    },
    {
      path: "/onlineServiceDetail/:seqId",
      name: "onlineServiceDetail",
      meta: {
        parent: 'onlineServiceList'
      },
      component: resolve => require(['./views/onlineService/detail.vue'], resolve)
    }, {
      path: "/requireSubmit",
      name: "requireSubmit",
      component: resolve => require(['./views/onlineService/requireSubmit.vue'], resolve)
    },
    {
      path: "/portalQueAnswerList",
      name: "portalQueAnswerList",
      component: resolve => require(['./views/agriculturalResources/list.vue'], resolve)
    },
    {
      path: "/tspList",
      name: "coteStyleList",
      component: resolve => require(['./views/coteStylePage/list.vue'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/tspSubDetail/:seqId",
      name: "coteStyleDetail",
      meta: {
        parent: 'coteStyleList'
      },
      component: resolve => require(['./views/coteStylePage/components/detail.vue'], resolve),
    },
    {
      path: "/tspDetail/:id",
      name: "coteStyleDetailPage",
      meta: {
        parent: 'coteStyleList'
      },
      component: resolve => require(['./views/coteStylePage/components/fjtecDetail.vue'], resolve),
    },

    {
      path: "/classCaseDetail/:newsId",
      name: "classCaseDetailPage",
      meta: {
        parent: 'onlineServiceList'
      },
      component: resolve => require(['./views/coteStylePage/components/classCaseDetail.vue'], resolve),
    },
    {
      path: "/serviceEffectList",
      name: "serviceEffectList",
      component: resolve => require(['./views/serviceEffectiveness/subIndex.vue'], resolve),
    },
    {
      path: "/technicalList",
      name: "technicalList",
      component: resolve => require(['./views/technical/list.vue'], resolve),
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/technicalDetail/:type/:seqId/",
      name: "technicalDetail",
      meta: {
        parent: 'technicalList'
      },
      component: resolve => require(['./views/technical/detail.vue'], resolve)
    },
    {
      path: "/searchResult",
      name: "searchResult",
      component: resolve => require(['./views/search/index.vue'], resolve)
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});